























import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import { i18n } from '@/Infrastructure/Intl/Intl'
import { FetchActivitiesByQueryCommandHandlerProvider } from '@/Infrastructure/Activities/Provider'
import { FetchActivitiesByQueryCommand, ActivityDto } from '@/Application/Activities'
interface SelectorOption {
  code: string;
  name: string;
}
interface SelectorData {
  currentOption: SelectorOption | null;
  options: SelectorOption[];
  disabled: boolean;
  loading: boolean;
}

export default Vue.extend({
  name: 'ActivitiesSelector',
  components: { Multiselect },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data (): SelectorData {
    return {
      currentOption: null,
      options: [] as { code: string; name: string }[],
      disabled: false,
      loading: false
    }
  },
  watch: {
    value (newValue: string, oldValue: string) {
      if (newValue !== oldValue) {
        this.findSelectedOption(newValue)
      }
    }
  },
  mounted () {
    this.onSearchChange('')
      .then(() => {
        this.findSelectedOption(this.value)
      })
  },
  methods: {
    findSelectedOption (value: string) {
      const selectedOption = this.options.find(current => current.code === value)
      this.currentOption = selectedOption || null
    },
    onSearchChange ($event: string): Promise<void> {
      const provider = new FetchActivitiesByQueryCommandHandlerProvider()
      const command = new FetchActivitiesByQueryCommand($event, i18n.locale)
      const handler = provider.provide()
      this.loading = true
      return handler.handle(command)
        .then((response: ActivityDto[]) => {
          this.options = response.map(current => {
            return { code: current.code, name: current.name }
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    onInput ($event: SelectorOption) {
      this.$emit('input', $event.code)
    }
  }
})
